// One in-play market line inside its event card: market name, flashing
// oracle price, hand-rolled sparkline. Suspended markets get a chip next
// to the name and a grayed price. Event identity lives in the card
// header, not here.

import { PriceChange } from '@mashtrade/ui';
import type { MarketSnapshot } from '../feed';
import { Sparkline } from './sparkline';
import { SuspendedChip } from './status-ribbon';

const priceLabel = (price: number | null): string | null =>
  price === null ? null : price.toFixed(2);

export function LiveMarketLine({ market }: { market: MarketSnapshot }) {
  const suspended = market.status === 'suspended';
  return (
    <div className="flex items-center gap-3 py-2">
      <p className="flex min-w-0 flex-1 items-center gap-1.5 truncate text-xs opacity-80">
        <span className="truncate">{market.displayName || market.name}</span>
        {suspended && <SuspendedChip />}
      </p>
      <Sparkline points={market.history} direction={market.priceDirection} />
      <PriceChange
        price={priceLabel(market.price)}
        direction={market.priceDirection}
        marketIndex={market.index}
        className={`w-16 justify-end text-base font-semibold tabular-nums ${suspended ? 'opacity-40' : ''}`}
      />
    </div>
  );
}
